import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import { SaveClientReport_Input } from 'generated/graphql';
import {
  Checkbox,
  FormControl,
  FormControlLabel
} from '@mui/material';

export type SaveClientReportFormProps = {
  id: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: SaveClientReportFormProps) => {
  const [
    fnSaveClientReportForm,
    { loading }
  ] = ds.useSaveClientReport();
  const form = ds.useFormState(props.id, props.projectId);
  const handleSubmit = async (input: SaveClientReport_Input) => {

    await fnSaveClientReportForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit({
          id: form.formState.id,
          approved: form.formState.approved,
          projectId: form.formState.projectId,
          description: form.formState.description
        });
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      {props.id !== '' && (
        <>
          <StyledTextField.FC
            {...form.genFieldProps('description')}
            minRows={4}
          />
          <FormControl>
            <FormControlLabel
              control={(
                <Checkbox
                  onClick={() => form.dispatch({
                    type: 'UPDATE',
                    payload: {
                      property: 'approved',
                      value: !form.formState.approved
                    }
                  })}
                  disabled={form.formState.disableApproval}
                  checked={form.formState.approved}
                />
              )}
              label='Approved'
            />
          </FormControl>
        </>
      )}
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
